<div class="sup-page">

  <!-- Toast -->
  <div class="sup-toast" *ngIf="toastMsg">
    <span class="material-icons">check_circle</span>{{ toastMsg }}
  </div>

  <!-- Page Header -->
  <div class="sup-page-header">
    <div>
      <div class="sup-page-title">Queue Monitor</div>
      <div class="sup-page-sub">Live interaction queue across all channels</div>
    </div>
    <div class="sup-page-actions">
      <span class="sup-badge sb-green">
        <span class="sup-live-dot"></span>Live
      </span>
    </div>
  </div>

  <!-- Stats Grid -->
  <div class="sup-stats-grid">
    <div *ngFor="let s of stats" class="sup-stat-card" [ngClass]="'sc-'+s.col">
      <div class="sup-stat-label">{{s.label}}</div>
      <div class="sup-stat-value">{{s.val}}</div>
    </div>
  </div>

  <!-- Live Queue Table -->
  <div class="sup-card">
    <div class="sup-card-header">
      <span class="sup-card-title">
        <span class="material-icons">layers</span>Live Queue
      </span>
      <span class="sup-badge sb-amber">{{ stats[0].val }} Waiting</span>
    </div>
    <div style="overflow-x:auto">
      <table class="sup-tbl">
        <thead>
          <tr>
            <th>Citizen</th>
            <th>Topic</th>
            <th>Channel</th>
            <th>Wait Time</th>
            <th>Priority</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of queue">
            <td style="font-weight:600">{{r.name}}</td>
            <td class="td2" style="max-width:260px;white-space:normal">{{r.topic}}</td>
            <td>
              <span class="sup-ch" [ngClass]="chClass(r.ch)">{{r.ch}}</span>
            </td>
            <td class="td-mono" [style.color]="waitColor(r.wait)">{{r.wait}}</td>
            <td>
              <div style="display:flex;align-items:center;gap:6px">
                <span class="sup-pri" [ngClass]="priClass(r.pri)"></span>
                <span style="font-size:12px">{{r.pri}}</span>
              </div>
            </td>
            <td>
              <span *ngIf="assignedIds.includes(r.queueId)" class="sup-badge sb-green">
                <span class="material-icons" style="font-size:11px">how_to_reg</span>Assigned
              </span>
              <button *ngIf="!assignedIds.includes(r.queueId)"
                      class="sup-btn btn-primary"
                      (click)="openAssignDialog(r)">
                <span class="material-icons" style="font-size:13px">person_add</span>Assign
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>

<div class="qm-dialog-backdrop" *ngIf="agentDialogFor">
  <div class="qm-dialog" role="dialog" aria-modal="true">
    <div class="qm-dialog-head">
      <div>
        <div class="qm-dialog-kicker">Assign Waiting Call</div>
        <div class="qm-dialog-title">{{ agentDialogFor.name }}</div>
        <div class="qm-dialog-sub">{{ agentDialogFor.ch }} - Waiting {{ agentDialogFor.wait }} - {{ agentDialogFor.pri }} priority</div>
      </div>
      <button class="qm-icon-btn" type="button" (click)="closeAssignDialog()" [disabled]="!!assigningAgentExt">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="qm-dialog-body">
      <div class="qm-loading" *ngIf="loadingAgents">
        <span class="material-icons">sync</span>
        Loading available agents...
      </div>

      <div class="qm-error" *ngIf="assignError && !loadingAgents">{{ assignError }}</div>

      <button class="qm-agent-row"
              type="button"
              *ngFor="let agent of availableAgents"
              (click)="assignToAgent(agent)"
              [disabled]="!!assigningAgentExt">
        <span class="qm-agent-avatar">{{ agentInitials(agent) }}</span>
        <span class="qm-agent-main">
          <strong>{{ agent.fullName }}</strong>
          <small>Extension {{ agent.sipExtension }}</small>
        </span>
        <span class="qm-agent-status">
          <span class="qm-status-dot"></span>
          {{ assigningAgentExt === agent.sipExtension ? 'Assigning...' : agent.status }}
        </span>
      </button>
    </div>
  </div>
</div>
